const cleanJobNameForSearch = (jobName: string): string => {
  return jobName.trim().normalize('NFKD').replace(/[^\w\s-_.:]/g, '').toLocaleLowerCase()
}

export default cleanJobNameForSearch
